module.exports = __webpack_public_path__ + "img/5_ava.06e6974e.jpg";